import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

import { TFAQModalContainerProps } from './types';
import { IAccordionOnClickParams, useAccordionsBehaviour } from './utils/useAccordionsBehaviour';
import { FAQModalContent } from './components';
import { trackFaqAccordionClick } from './tracking';

export const FAQModalContainer: React.FC<React.PropsWithChildren<TFAQModalContainerProps>> = props => {
  const { accordionsCollectionRef, onAccordionClick, activeAccordeonIndex } = useAccordionsBehaviour({
    isModalOpen: props.open,
    activeAccordeonIndex: null,
  });

  if (!props.open) {
    return null;
  }
  const { category, questions, onClose } = props;
  const onAccordionClickWithTracking = (params: IAccordionOnClickParams) => {
    /* istanbul ignore else */
    if (!params.isActive) {
      trackFaqAccordionClick(category, params.title);
    }

    onAccordionClick(params);
  };

  return (
    <ModalWindow open onClose={onClose} maxWidth={880}>
      <FAQModalContent
        title={category}
        questions={questions}
        accordionsCollectionRef={accordionsCollectionRef}
        onAccordionClick={onAccordionClickWithTracking}
        activeAccordeonIndex={activeAccordeonIndex}
      />
    </ModalWindow>
  );
};
